import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { IDeliveryAddress, PlacedOrderDisplayModel } from 'src/app/store/services/order.service';
import { OrderService } from 'src/app/store/services/order.service';
//import {TranslateService} from '@ngx-translate/core';
import { MenuService } from 'src/app/store/services/menu.service';
import { IStoreAddress, StoreService } from 'src/app/store/services/store.service';
import { AddressEditorModalComponent } from 'src/app/shared/components/address-editor-modal/address-editor-modal.component';
@Component({
    selector: 'app-confirm-reorder',
    templateUrl: './confirm-reorder.component.html',
    styleUrls: ['./confirm-reorder.component.scss'],
    standalone: false
})
export class ConfirmReorderComponent implements OnInit {
  @Input() item: any[];
  @Input() storeId: string;
  @Input() orderType: string;
  @Input() change: boolean=false;
  @Input() noItem: boolean = false;
  @Input() unavailableItems: any[];
  @Input() changedPriceItems: any[];
  @Input() deliveryAddress: IDeliveryAddress;
  storeAddress: IStoreAddress;
  confirmedAddress: boolean = false;

  constructor( private modalCtrl: ModalController,
      private route: Router,
      private orderService: OrderService,
      private storeService: StoreService,
      //public translateService: TranslateService,
      public menuService: MenuService
      ) { }

  async ngOnInit() {
    if(this.orderType == "pickup"){
      this.storeService.getStore(this.storeId).subscribe(store => {
        this.storeAddress = store.address;
      });
    } else if (this.orderType == "delivery"){
      localStorage.setItem("deliveryAddress", JSON.stringify(this.deliveryAddress));
    }

    //await this.menuService.getStore(this.storeId);
  }

  continue() {
    let date=new Date();
    localStorage['cartStorage']=JSON.stringify(this.item);
    localStorage['TimeLimit']=date.getDate();
    localStorage['StoreId']=this.storeId;
    this.route.navigateByUrl(`/stores/menu/${this.storeId}/${this.orderType}`);
    this.orderService.reOrder=true;

    //await this.menuService.getStore(this.storeId);
    /*
    if (window.innerWidth < 1100) {
      this.menuService.cart();
    } else {
      this.menuService.desktopCart(1);
    }*/

    this.modalCtrl.dismiss();
  }

  discontinue() {
    this.modalCtrl.dismiss();
  }

  next(){
    if(this.change){
      this.unavailableItems = null;
    } else {
      this.continue();
    }
  }
  confirmAddress(){
    this.confirmedAddress = true;
    if(!this.unavailableItems && !this.change && !this.noItem){
      this.continue();
    }
  }
  async changeAddress(){
    const modal = await this.modalCtrl.create({
      component: AddressEditorModalComponent,
      componentProps: {
        skipProvinceValidation: true,
        isReservation: false,
        storeId: this.storeId
      },
      cssClass: 'custom-border-modal-css'
    });

    modal
      .onDidDismiss()
      .then(async (result) => {
        if (!result.data)
          return;

        localStorage.setItem("deliveryAddress", JSON.stringify(result.data));
        this.deliveryAddress = result.data;
      });

    await modal.present();
  }
}


